export const isWebsiteFreemium = (url: string) => {
  return url.includes('wixsite.com') || url.includes('editorx.com');
};
